import { MessageCircle } from "lucide-react";
import { buildWaLink } from "@/lib/constants";

export default function WhatsAppFloat() {
  return (
    <a
      href={buildWaLink()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float"
      className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-[0_8px_32px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform wa-pulse"
    >
      <MessageCircle size={24} strokeWidth={1.6} />
    </a>
  );
}
